import Image1 from "./../../static/platform.jpg";
import Image2 from "./../../static/green.jpg";

export const SOCIAL_DATA = [
  {
    id: 1,
    image: Image1,
    post: "All sielence at Gorkhpur station at mid night....",
  },
  {
    id: 2,
    image: Image2,
    post: "Green all around....",
  },
];
